import './Fixture.css';

import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import Team from '@views/Team';
import { Switch } from 'antd';

const formatTime = (dateStr) => moment(dateStr).format('HH:mm');

// HACK: locale not working, hardcoding month names
const formatDate = (dateStr, now) => {
  const result = moment(dateStr)
    .format('DD [de] MMMM')
    .replace('November', 'Noviembre')
    .replace('December', 'Diciembre');
  return result;
};

const getMatchTitle = (match) => {
  if (match.stage === 'groups') {
    return `Grupo ${match.group}`;
  }
  if (match.round === 'roundof32') {
    return `Dieciseisavos de final`;
  }
  if (match.round === 'roundof16') {
    return `Octavos de final`;
  }
  if (match.round === 'quarter') {
    return `Cuartos de final`;
  }
  if (match.round === 'semi') {
    return `Semi final`;
  }
  if (match.round === 'third') {
    return `Tercer puesto`;
  }
  if (match.round === 'final') {
    return `Final`;
  }
  return '';
};

const getMatchTitleClass = (match) => {
  if (match.stage === 'groups') {
    return `group-${match.group}`;
  }
  return match.round;
};

const Fixture = ({ isReady, matchesByDate, now, isEmbed }) => {
  const [viewPast, setViewPast] = React.useState(
    !!localStorage.getItem('fixture-past')
  );

  if (!isReady) {
    return <h3>Cargando...</h3>;
  }
  const matchesByDateFiltered = matchesByDate.filter(([date]) => {
    if (viewPast || isEmbed) {
      return true;
    }
    return moment(date).isSameOrAfter(now.slice(0, 10));
  });
  return (
    <div className="fixture-view">
      {isEmbed ? null : (
        <div className="controls">
          <span>Ver fechas pasadas</span>
          <Switch
            onChange={(checked) => {
              localStorage.setItem('fixture-past', checked ? true : '');
              setViewPast(checked);
            }}
            checked={viewPast}
          />
        </div>
      )}
      {matchesByDateFiltered.map(([date, matches], i) => {
        return (
          <div key={date} className="date-group">
            <h3>{formatDate(date, now)}</h3>
            <div>
              {matches.map((m) => {
                return (
                  <div key={m.mid} className="match">
                    <div className="match-real">
                      <div className={`match-header ${getMatchTitleClass(m)}`}>
                        {getMatchTitle(m)}
                      </div>
                      <div className="match-content">
                        <span className="time">{formatTime(m.datetime)}</span>
                        <div className="teams">
                          <div className="team team-home">
                            <Team code={m.teamHome} align="right" />
                            <span className="score">{m.scoreHome}</span>
                          </div>
                          <div className="team team-away">
                            <span className="score">{m.scoreAway}</span>
                            <Team code={m.teamAway} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Fixture.displayName = 'Fixture';
Fixture.propTypes = {
  isReady: PropTypes.bool,
  groups: PropTypes.object,
  groupWinners: PropTypes.array,
  brackets: PropTypes.object,
  bracketWinners: PropTypes.object,
  champion: PropTypes.object,
  scorer: PropTypes.object,
  total: PropTypes.number,
};
Fixture.defaultProps = {
  isReady: false,
};

export default Fixture;
